import React from "react";
import './Footer.css'
import idscLogo from '../../utils/assets/images/idsclogo.png'
const Footer = () => {
    return(
        <>
        <div className="footer-wrapper">
            <p>All Rights reserved 2024
            <img className="mx-2" src={idscLogo} alt="IDSC Logo"/>
            &copy; Information & Decision support center Egyptian Cabient</p>
            
        </div>
        </>
    )
}
export default Footer